import { TabbedFlipboardSplitCardType } from '@models/ITabbedFlipboard';
import TabbedFlipboardCardTypeEnum from '@models/enums/TabbedFlipboardCardTypeEnum';
import usePreviewMode from '@utils/hooks/usePreviewMode';
import classNames from 'classnames';
import TabbedFlipboardSmallMediaCard from './TabbedFlipboardSmallMediaCard';
import TabbedFlipboardSmallTextCard from './TabbedFlipboardSmallTextCard';

interface Props extends Omit<TabbedFlipboardSplitCardType, 'type'> {
  readonly index: number;
}

const TabbedFlipboardSplitCard = ({
  topCard,
  bottomCard,
  index,
  meta,
}: Props) => {
  const isPreview = usePreviewMode();

  return (
    <div
      className={classNames('flex h-full flex-col gap-y-4', {
        'max-h-[540px] max-w-[540px]': isPreview,
      })}
    >
      <div
        className="h-[calc(50%-8px)]"
        data-testid={`CT-159-Tabbed-Flipboard-Split-Card-Top-${index}`}
        data-epi-property-name={meta?.editHints?.topCard}
      >
        {topCard.type === TabbedFlipboardCardTypeEnum.SmallMedia && (
          <TabbedFlipboardSmallMediaCard
            headline={topCard.headline}
            media={topCard.media}
          />
        )}

        {topCard.type === TabbedFlipboardCardTypeEnum.SmallText && (
          <TabbedFlipboardSmallTextCard
            stat={topCard.stat}
            icon={topCard.icon}
            body={topCard.body}
          />
        )}
      </div>

      <div
        className="h-[calc(50%-8px)]"
        data-testid={`CT-159-Tabbed-Flipboard-Split-Card-Bottom-${index}`}
        data-epi-property-name={meta?.editHints?.bottomCard}
      >
        {bottomCard.type === TabbedFlipboardCardTypeEnum.SmallMedia && (
          <TabbedFlipboardSmallMediaCard
            headline={bottomCard.headline}
            media={bottomCard.media}
          />
        )}

        {bottomCard.type === TabbedFlipboardCardTypeEnum.SmallText && (
          <TabbedFlipboardSmallTextCard
            stat={bottomCard.stat}
            icon={bottomCard.icon}
            body={bottomCard.body}
          />
        )}
      </div>
    </div>
  );
};

export default TabbedFlipboardSplitCard;
